import React, { useEffect, useState } from 'react';
interface PriceDisplayProps {
  amount: string;
  className?: string;
}
export function PriceDisplay({
  amount,
  className = ''
}: PriceDisplayProps) {
  const [currencySymbol, setCurrencySymbol] = useState('$');
  useEffect(() => {
    const locale = navigator.language || 'en-US';
    const currencyMap: {
      [key: string]: string;
    } = {
      'es-ES': '€',
      'en-GB': '£',
      'en-US': '$',
      'es-MX': '$',
      'es-AR': '$',
      'es-CO': '$',
      'es-CL': '$',
      'es-PE': '$',
      'pt-BR': 'R$'
    };
    const symbol = currencyMap[locale] || '$';
    setCurrencySymbol(symbol);
  }, []);
  return <span className={className} data-id="element-94">
      {currencySymbol}
      {amount}
    </span>;
}